import { Transforms, Path, Editor, Point, Range, Node, Element as SlateElement } from 'vendor/slate'
import { ReactEditor } from 'vendor/slate-react'
import { ELEMENT_TYPES, HINT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertHint = (editor, path) => {
  const hint = {
    type: ELEMENT_TYPES.hint,
    hintType: HINT_TYPES.info,
    children: [
      {
        type: ELEMENT_TYPES.hint_content,
        parent: { type: ELEMENT_TYPES.hint },
        children: [
          {
            type: ELEMENT_TYPES.default,
            parent: { type: ELEMENT_TYPES.hint_content },
            children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.default } }]
          }
        ]
      }
    ]
  }

  Transforms.insertNodes(editor, hint, { at: path, select: true })
  ReactEditor.focus(editor)
}

const withHints = editor => {
  const { deleteBackward } = editor
  editor.deleteBackward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const { anchor } = selection
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n => !Editor.isEditor(n) && [ELEMENT_TYPES.hint_content].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [, path] = match
        const start = Editor.start(editor, Path.parent(path))

        if (Point.equals(anchor, start)) {
          return
        }
      }
    }

    deleteBackward(unit)
  }

  return editor
}
export { insertHint, withHints }
